<template>
  <b-modal
    id="dynamic-function-modal"
    size="lg"
    centered
    hide-footer
    @hidden="resetModal"
    @close="resetModal"
    no-close-on-backdrop
    no-close-on-esc
    :title="modalTitle"
  >
    <b-container fluid>
      <div class="form-container">
        <b-form-group label-for="function-select" class="mb-4">
          <b-row>
            <b-col cols="6">
              <basic-select
                id="function-select"
                v-model="selectedFunction"
                :options="functionOptions"
                :track-by="'value'"
                value-label="text"
                label="Chọn chức năng"
                placeholder="Chọn chức năng"
                @change="onFunctionChange"
              ></basic-select>
            </b-col>
            <b-col cols="6">
              <basic-select
                id="userPackages"
                label="Chọn UserPackages"
                :options="userPackages"
                track-by="Id"
                value-label="Name"
                v-model="userPackage"
                placeholder="Chọn UserPackages"
                :key="userPackagesKey"
              ></basic-select>
            </b-col>
          </b-row>
        </b-form-group>

        <div v-if="selectedFunction">
          <basic-date-picker
            v-if="selectedFunction === 'change'"
            v-model="changeDate"
            label="Ngày thêm hoạt động"
            placeholder="Ngày thêm hoạt động"
            name="startDate"
            data-vv-As="Ngày thêm hoạt động"
            format="YYYY-MM-DD"
          />
        </div>
        <div class="d-flex justify-content-end w-100">
          <b-button class="btn ml-3" @click.stop="closeModal">Hủy</b-button>
          <b-button
            class="btn btn-success ml-3"
            @click.stop="updateUserPackageStartDate"
          >
            <span class="svg-icon">
              <inline-svg :src="`/media/svg/icons/Neolex/Basic/save.svg`" />
            </span>
            Chỉnh sửa
          </b-button>
        </div>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import reminderAiService from '@/view/pages/reminder_ai/services/reminderAiService';

export default {
  name: 'DynamicModal',
  props: {
    setupData: {
      type: Object,
      default: () => {},
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedFunction: null,
      userPackage: null,
      changeDate: null,
      userPackagesKey: 0,
      functionOptions: [
        { value: 'change', text: 'Thay đổi thời gian bắt đầu UserPackage' },
        // { value: 'stop', text: 'Tạm dừng UserPackage' },
        { value: 'delete', text: 'Xóa UserPackage' },
      ],
    };
  },
  computed: {
    modalTitle() {
      if (!this.selectedFunction) return 'Chọn chức năng';
      switch (this.selectedFunction) {
        case 'change':
          return 'Thay đổi ngày UserPackage';
        case 'stop':
          return 'Dừng UserPackage';
        case 'delete':
          return 'Xóa UserPackage';
        default:
          return 'Chọn chức năng';
      }
    },
  },
  watch: {
    selectedItem: {
      handler(newVal) {
        this.userPackages = newVal.userPackages;
        this.userPackagesKey += 1;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    resetModal() {
      this.selectedFunction = null;
      this.userPackage = null;
      this.changeDate = null;
      this.$bvModal.hide('dynamic-function-modal');
    },
    closeModal() {
      this.$bvModal.hide('dynamic-function-modal');
    },
    openModal() {
      this.$bvModal.show('dynamic-function-modal');
    },
    onFunctionChange() {
      this.$emit('function-changed', this.selectedFunction);
    },

    async updateUserPackageStartDate() {
      try {
        if (!this.selectedFunction) {
          this.$toastr.e({
            title: 'Lỗi',
            msg: 'Vui lòng chọn chức năng',
          });
          return;
        }

        if (!this.userPackage) {
          this.$toastr.e({
            title: 'Lỗi',
            msg: 'Vui lòng chọn UserPackage',
          });
          return;
        }

        if (this.selectedFunction == 'change') {
          if (this.selectedFunction === 'change' && !this.changeDate) {
            this.$toastr.e({
              title: 'Lỗi',
              msg: 'Vui lòng chọn ngày thay đổi UserPackage',
            });
            return;
          }
          let confirm = await this.$swal({
            text: `${'Bạn có chắc muốn thay đổi ngày bắt đầu của UserPackage này không?'}`,
            icon: 'warning',
            buttons: {
              cancel: {
                text: 'Huỷ',
                value: false,
                visible: true,
                className: '',
                closeModal: true,
              },
              confirm: {
                text: 'Xác nhận',
                value: true,
                visible: true,
                className: 'btn-success',
                closeModal: true,
              },
            },
          });
          if (confirm) {
            this.loading = true;
            const timestamp = Math.floor(
              new Date(this.changeDate).getTime() / 1000,
            );
            await this.$api.put(
              `TranUserPackage?userPackageId=${this.userPackage}&startDate=${timestamp}`,
            );
          }
        } else if (this.selectedFunction == 'delete') {
          let confirm = await this.$swal({
            text: `${'Bạn có chắc muốn xóa UserPackage này không?'}`,
            icon: 'warning',
            buttons: {
              cancel: {
                text: 'Huỷ',
                value: false,
                visible: true,
                className: '',
                closeModal: true,
              },
              confirm: {
                text: 'Xác nhận',
                value: true,
                visible: true,
                className: 'btn-success',
                closeModal: true,
              },
            },
          });
          if (confirm) {
            this.loading = true;
            await this.$api.delete(
              `TranUserPackage?userPackageId=${this.userPackage}`,
            );
            // Xoá kèm nháp gợi ý AI trên Redis để không còn trỏ tới UserPackage đã mất.
            // Best-effort: lỗi ở đây không chặn luồng xoá chính (nháp tự hết hạn sau 48h).
            try {
              await reminderAiService.discardDraft(this.userPackage);
            } catch (e) {
              // ignore
            }
            this.$router.push({
              name: 'tran_user_package_list',
            });
          }
        } 
        this.$emit('reset-request');
        this.closeModal();
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.form-container {
  padding: 15px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}

#dynamic-function-modal {
  padding: -0.25rem !important;
}
</style>
